import { isEmpty, trim } from 'lodash';
import { removeHtmlTags } from './string';
export function isNotFalsy(value) {
    if (value == null) {
        return false;
    }
    return true;
}
export function isNotEmpty(value) {
    if (typeof value === 'string') {
        return !isEmpty(trim(value));
    }
    return !isEmpty(value);
}
export function isNotEmptyIgnoreTags(value) {
    if (typeof value === 'string') {
        return !isEmpty(trim(removeHtmlTags(value)));
    }
    return !isEmpty(value);
}
